// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style--contentWrapper--53783b","label":"style--label--cfe510"};